<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeModal">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if(formLoaded) {
		<form class="fade-in">
			<div class="modal-body">
				<div class="row">
					<div class="col-8">
						@if(systemSourceField) {
							<div class="rounded-panel d-flex align-items-center p-3 alert alert-danger" role="alert">
								This is a system Source Field and some fields cannot be modified.
							</div>
						}
						<div class="char-data__group">
							<rl-form-table-row [labelText]="'Field Name'" [required]="true"
								[class.has-error]="form.controls.sourceFieldName.touched && form.invalid && form.controls.sourceFieldName.value === ''">
								<ng-template rlFormTableControl>
									<rl-text-input [formControl]="form.controls.sourceFieldName"
										[dataLabel]="'textInputFieldName'"></rl-text-input>
								</ng-template>
								@if (form.controls.sourceFieldName.touched && form.invalid && form.controls.sourceFieldName.value === '') {
									<ng-template rlFormTableMessage>
										Field Name is required.
									</ng-template>
								}
							</rl-form-table-row>

							<rl-form-table-row [labelText]="'Tag Label'" [required]="true"
								[class.has-error]="(form.controls.sourceFieldName.touched || form.controls.mergeTag.touched) && form.invalid && form.controls.mergeTag.value === ''">
								<ng-template rlFormTableControl>
									<rl-text-input [formControl]="form.controls.mergeTag"
										[dataLabel]="'textInputTagLabel'"></rl-text-input>
								</ng-template>
								@if ((form.controls.sourceFieldName.touched || form.controls.mergeTag.touched) && form.invalid && form.controls.mergeTag.value === '') {
									<ng-template rlFormTableMessage>
										Tag Label is required.
									</ng-template>
								}
							</rl-form-table-row>

							<rl-form-table-row [labelText]="'Tag Label Description'">
								<ng-template rlFormTableControl>
									<rl-text-input [formControl]="form.controls.description"
										[dataLabel]="'textInputDescription'"></rl-text-input>
								</ng-template>
							</rl-form-table-row>


							<rl-form-table-row [labelText]="'Data Type'">
								<ng-template rlFormTableControl>
									<rl-dropdown-single [(formControl)]="form.controls.dataType"
										[options]="dataTypeList" [showEmptyOption]="true"
										[dataLabel]="'selectDropdownDataType'">
									</rl-dropdown-single>
								</ng-template>
							</rl-form-table-row>

							@if(showMultiIndicator) {
								<rl-form-table-row [labelText]="'Can be Multiple'">
									<ng-template rlFormTableControl>
										<rl-checkbox-input
											[label]="!!form.controls.multipleIndicator.value ? 'Yes' : ''"
											[formControl]="form.controls.multipleIndicator"
											[dataLabel]="'checkboxInputMultipleYes'"
											class="d-block py-1"></rl-checkbox-input>
									</ng-template>
								</rl-form-table-row>
							}

							<rl-form-table-row [labelText]="'Max Length'">
								<ng-template rlFormTableControl>
									<rl-number-input [formControl]="form.controls.length"
										[dataLabel]="'numberInputMaxLength'"></rl-number-input>
								</ng-template>
							</rl-form-table-row>

							<!-- Only show the PickList Source field if Data Type is set to AlphaNum, Money or Checkbox (Classic parity) -->
							@if(picklistDataTypeIds.includes(getNumericValue($safeNavigationMigration(form.controls.dataType.value?.key)))) {
								<rl-form-table-row [labelText]="'Picklist Source'">
									<ng-template rlFormTableControl>
										<rl-dropdown-single [(formControl)]="form.controls.charValueSet"
											[options]="pickListSourceList" [showEmptyOption]="true"
											[dataLabel]="'selectDropdownPicklistSource'">
										</rl-dropdown-single>
									</ng-template>
								</rl-form-table-row>
							}


							<rl-form-table-row [labelText]="'System Indicator'">
								<ng-template rlFormTableControl>
									<rl-number-input [formControl]="form.controls.systemIndicator"
										[dataLabel]="'numberInputSystemIndicator'"></rl-number-input>
								</ng-template>
							</rl-form-table-row>

							<rl-form-table-row [labelText]="'Report Indicator'">
								<ng-template rlFormTableControl>
									<rl-checkbox-input [label]="!!form.controls.reportIndicator.value ? 'Yes' : ''"
										[formControl]="form.controls.reportIndicator"
										[dataLabel]="'checkboxInputReportIndicatorYes'"
										class="d-block py-1"></rl-checkbox-input>
								</ng-template>
							</rl-form-table-row>

							@if(shouldAllowUniqueEnforcement) {
								<rl-form-table-row [labelText]="'Enforce Uniqueness'">
									<ng-template rlFormTableControl>
										<rl-checkbox-input
											[label]="!!form.controls.enforceUniqueness.value ? 'Yes' : ''"
											[formControl]="form.controls.enforceUniqueness"
											[dataLabel]="'checkboxInputEnforceUniquenessYes'"
											(onValueChange)="toggleSidePanel(cancelEnforceUniqueness,$event)"
											class="d-block py-1"></rl-checkbox-input>
										<div class="alert alert-warning mt-3 mb-0">
											Enforcing uniqueness helps to prevent erroneous data if this Field is used
											in
											calculations. However, validation errors will appear on records that have
											duplicate
											data in this Field.
										</div>
									</ng-template>
								</rl-form-table-row>
							}
						</div>
					</div>
					<div class="col-4 px-2">
						@if(sourceField?.sourceFieldID && sourceField?.usedIn?.length > 0) {
							@if(displayTabs) {
								<ul ngbNav #nav="ngbNav" class="nav-tabs">
									<li ngbNavItem [id]="'usedIn'">
										<a ngbNavLink>
											Used In
										</a>
										<ng-template ngbNavContent>
											<rl-source-field-used-in-panel
												[sourceField]="sourceField"></rl-source-field-used-in-panel>
										</ng-template>
									</li>
									<li ngbNavItem [id]="'unique'">
										<a ngbNavLink>
											Uniqueness Validation (Admin)
										</a>
										<ng-template ngbNavContent>
											<rl-source-field-uniqueness-validation-panel
												[sourceField]="sourceField"></rl-source-field-uniqueness-validation-panel>
										</ng-template>
									</li>
								</ul>
								<div [ngbNavOutlet]="nav"></div>
							} @else {
								@if(sourceField?.sourceFieldID && sourceField?.usedIn?.length > 0) {
									<rl-source-field-used-in-panel
										[sourceField]="sourceField"></rl-source-field-used-in-panel>
								}
							}
						}
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="cancelButton">Cancel</button>
				<button class="btn btn-success" [disabled]="form.invalid || isSaving" (click)="submit($event)"
					data-cy="saveButton">@if (isSaving) {
						<i class="fal fa-spinner fa-spin me-1"></i>
					}Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="9"></rl-form-placeholder>
		</div>
	}
</div>

<ng-template #cancelEnforceUniqueness let-prompt="prompt">
	@if(form.controls.enforceUniqueness.value) {
		<div>
			<p>Enforcing uniqueness will cause validation errors on Records with duplicate data in this Field.</p>
			<p>Are you sure you want to enforce uniqueness on this Field?</p>
		</div>
	} @else {
		<div>
			<p>Enforcing uniqueness helps to prevent erroneous data if this Field is used in calculations.</p>
			<p>Are you sure you do NOT want to enforce uniqueness on this Field?</p>
		</div>
	}
	<div class="text-end mt-3 w-100">
		<button class="btn btn-light btn-sm" (click)="prompt.onConfirm.next(false)"
			data-cy="buttonCancel">Cancel</button>
		<button class="btn btn-success btn-sm ms-2" (click)="prompt.onConfirm.next(true)"
			data-cy="buttonYes">Yes</button>
	</div>
</ng-template>